import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sf-app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {
  @Input() loading: boolean;
  constructor() { }

  ngOnInit() {
  }

}
